import { Component } from '@angular/core';
import { TranslationService } from '../../translations';

@Component({
    selector: 'billing-payment-details',
    template: `
        <div class="detail-title">
            {{ TR.key('billing-manager.billing-payment-details-title') }}
        </div>
        <br />
        <div class="detail-flex">
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-ach-title'
                            )
                        }}
                    </dd>
                    <dd>
                        <a class="info-link" (click)="toggleACHPeekPanel(true)">
                            &#9432;
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-ach-info'
                                )
                            }}
                        </a>
                    </dd>
                </dl>
            </div>
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-wire-title'
                            )
                        }}
                    </dd>
                    <dd>
                        <a
                            class="info-link"
                            (click)="toggleWirePeekPanel(true)"
                        >
                            &#9432;
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-wire-info'
                                )
                            }}
                        </a>
                    </dd>
                </dl>
            </div>
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-check-title'
                            )
                        }}
                    </dd>
                    <dd>
                        <a
                            class="info-link"
                            (click)="toggleCheckPeekPanel(true)"
                        >
                            &#9432;
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-check-info'
                                )
                            }}
                        </a>
                    </dd>
                </dl>
            </div>
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-credit-title'
                            )
                        }}
                    </dd>
                    <dd>
                        <a class="info-link" (click)="toggleCCPeekPanel(true)">
                            &#9432;
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-credit-info'
                                )
                            }}
                        </a>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="detail-flex">
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-ach-details'
                            )
                        }}
                    </dd>
                    <dd class="payment-detail">ABA Routing: 121 137 522</dd>
                    <dd class="payment-detail">Swift Code: MNBDUS33</dd>
                </dl>
            </div>
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-wire-details'
                            )
                        }}
                    </dd>
                    <dd class="payment-detail">ABA Routing: 121 137 522</dd>
                    <dd class="payment-detail">Swift Code: MNBDUS33</dd>
                </dl>
            </div>
            <div>
                <dl>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-mailing-address'
                            )
                        }}
                    </dd>
                    <dd class="payment-detail">PO Box 675320</dd>
                    <dd class="payment-detail">Detroit, MI 48267-5320</dd>
                    <br />
                    <dd class="payment-detail">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-remit-checks'
                            )
                        }}
                    </dd>
                    <dd class="payment-type">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-pi-company-name'
                            )
                        }}
                    </dd>
                </dl>
            </div>
            <div>
                <dl>
                    <a class="info-link" (click)="toggleCCPeekPanel(true)">
                        {{
                            TR.key(
                                'billing-manager.billing-payment-details-credit-learn'
                            )
                        }}
                    </a>
                </dl>
            </div>
        </div>
        <peek-panel
            id="ach-peek-panel"
            [open]="openACHPeekPanel"
            (close)="openACHPeekPanel = false"
        >
            <account-billing-ach-panel
                (closePanel)="toggleACHPeekPanel($event)"
            ></account-billing-ach-panel>
        </peek-panel>
        <peek-panel
            id="wire-peek-panel"
            [open]="openWirePeekPanel"
            (close)="openWirePeekPanel = false"
        >
            <account-billing-wire-panel
                (closePanel)="toggleWirePeekPanel(false)"
            ></account-billing-wire-panel>
        </peek-panel>
        <peek-panel
            id="check-peek-panel"
            [open]="openCheckPeekPanel"
            (close)="openCheckPeekPanel = false"
        >
            <account-billing-check-panel
                (closePanel)="toggleCheckPeekPanel(false)"
            ></account-billing-check-panel>
        </peek-panel>
        <peek-panel
            id="cc-peek-panel"
            [open]="openCCPeekPanel"
            (close)="openCCPeekPanel = false"
        >
            <account-billing-credit-card-panel
                (closePanel)="toggleCCPeekPanel(false)"
            ></account-billing-credit-card-panel>
        </peek-panel>
    `,
    styleUrls: ['./account-billing-manager.less'],
    standalone: false
})
export class AccountBillingPaymentDetailsComponent {
    openACHPeekPanel: boolean;
    openWirePeekPanel: boolean;
    openCheckPeekPanel: boolean;
    openCCPeekPanel: boolean;

    constructor(public TR: TranslationService) {}

    toggleACHPeekPanel(val: boolean) {
        this.openACHPeekPanel = val;
    }

    toggleWirePeekPanel(val: boolean) {
        this.openWirePeekPanel = val;
    }

    toggleCheckPeekPanel(val: boolean) {
        this.openCheckPeekPanel = val;
    }

    toggleCCPeekPanel(val: boolean) {
        this.openCCPeekPanel = val;
    }
}
